import { ActionType } from 'flow/store/engine/constants';

// Action types that are allowed to have name collisions
export const ACTION_TYPES_ALLOWING_NAME_COLLISIONS: ActionType[] = [
  ActionType.TAG,
  ActionType.SERVICE,
];

// Action types that are allowed to have name collisions when auto-resolving names
//   eg. during node duplication and merge
export const ACTION_TYPES_ALLOWING_AUTO_RESOLVED_NAME_COLLISIONS: ActionType[] = [
  ActionType.SERVICE,
];

export const REGEX = {
  // Any action public id
  ACTION_PUBLIC_ID: /action__\w*__\w{20}/,

  // Action types
  EXIT_ACTION_PUBLIC_ID: /action__exit__\w{20}/,
  IMPORTED_MATRIX_MODEL_PUBLIC_ID: /action__imported_matrix_model__\w{20}/,
  IMPORTED_OUTPUT_ATTRIBUTE_PUBLIC_ID: /action__imported_output_attribute__\w{20}/,
  INPUT_ACTION_PUBLIC_ID: /action__input__\w{20}/,
  MATRIX_MODEL_ACTION_PUBLIC_ID: /action__matrix_model__\w{20}/,
  OUTPUT_ACTION_PUBLIC_ID: /action__output__\w{20}/,
  TAG_ACTION_PUBLIC_ID: /action__tag__\w{20}/,
  SERVICE_PUBLIC_ID: /action__service__\w{20}/,
  OUTCOME_ACTION_PUBLIC_ID: /action__outcome__\w{20}/,
  OUTCOME_REASON_ACTION_PUBLIC_ID: /action__outcome_reason__\w{20}/,
  PREVIEW_ACTION_PUBLIC_ID: /action__preview__\w{20}/,
  WORKFLOW_ROUTING_ACTION_PUBLIC_ID: /action__workflow__\w{20}/,
};

export const ActionTypeToRegex: Record<ActionType, RegExp> = {
  [ActionType.EXIT]: REGEX.EXIT_ACTION_PUBLIC_ID,
  [ActionType.IMPORTED_MATRIX_MODEL]: REGEX.IMPORTED_MATRIX_MODEL_PUBLIC_ID,
  [ActionType.IMPORTED_OUTPUT_ATTRIBUTE]: REGEX.IMPORTED_OUTPUT_ATTRIBUTE_PUBLIC_ID,
  [ActionType.INPUT]: REGEX.INPUT_ACTION_PUBLIC_ID,
  [ActionType.MATRIX_MODEL]: REGEX.MATRIX_MODEL_ACTION_PUBLIC_ID,
  [ActionType.OUTPUT]: REGEX.OUTPUT_ACTION_PUBLIC_ID,
  [ActionType.TAG]: REGEX.TAG_ACTION_PUBLIC_ID,
  [ActionType.SERVICE]: REGEX.SERVICE_PUBLIC_ID,
  [ActionType.OUTCOME]: REGEX.OUTCOME_ACTION_PUBLIC_ID,
  [ActionType.OUTCOME_REASON]: REGEX.OUTCOME_REASON_ACTION_PUBLIC_ID,
  [ActionType.PREVIEW]: REGEX.PREVIEW_ACTION_PUBLIC_ID,
  [ActionType.WORKFLOW]: REGEX.WORKFLOW_ROUTING_ACTION_PUBLIC_ID,
};
